const call = () => {
    return {
        open: false,

        title: "Confirm",
        message: "Are you sure?",
        yesText: "Yes",
        noText: "No",

        yesCallback: function () {
            this.hideDialog()
        },
        noCallback: function () {
            this.hideDialog()
        },

        showDialog(title, message, yesText, noText, yesCallback, noCallback) {
            if (yesCallback) {
                this.yesCallback = yesCallback
            }

            if (noCallback) {
                this.noCallback = noCallback
            }

            this.title = title || "Confirm"
            this.message = message || "Are you sure?"
            this.yesText = yesText || "Yes"
            this.noText = noText || "No"

            this.open = true
        },

        hideDialog() {
            this.open = false
        },
    };
};

export default call;